import { motion } from 'framer-motion';

const PrivacyContent = () => {
  const contentVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="bg-white/40 rounded-lg shadow-sm p-8">
      {/* Information Collection */}
      <motion.div
        id="collection"
        className="mb-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={contentVariants}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Information We Collect</h2>
        <p className="text-gray-600 leading-relaxed">
          We may collect personal information you provide voluntarily, such as your name, email address, 
          or any other details you submit through forms. We also collect limited non-personal data 
          (like browser type or pages visited) to improve your experience.
        </p>
      </motion.div>

      {/* Information Usage */}
      <motion.div
        id="usage"
        className="mb-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={contentVariants}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-4">How We Use Your Information</h2>
        <p className="text-gray-600 leading-relaxed">
          We use your information to respond to inquiries, provide requested services, improve our website, 
          and communicate with you if you have opted in.
        </p>
      </motion.div>

      {/* Information Sharing */}
      <motion.div
        id="sharing"
        className="mb-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={contentVariants}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Sharing Your Information</h2>
        <p className="text-gray-600 leading-relaxed">
          We do not sell, rent, or share your personal information with third parties except as required 
          by law or to protect our rights.
        </p>
      </motion.div>

      {/* Cookies */}
      <motion.div
        id="cookies"
        className="mb-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={contentVariants}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Cookies</h2>
        <p className="text-gray-600 leading-relaxed">
          Our website may use cookies to enhance user experience. You can modify your browser settings 
          to decline cookies if you prefer.
        </p>
      </motion.div>

      {/* Data Security */}
      <motion.div
        id="security"
        className="mb-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={contentVariants}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Data Security</h2>
        <p className="text-gray-600 leading-relaxed">
          We implement reasonable security measures to protect your data from unauthorized access or disclosure.
        </p>
      </motion.div>

      {/* User Rights */}
      <motion.div
        id="rights"
        className="mb-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={contentVariants}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Your Rights</h2>
        <p className="text-gray-600 leading-relaxed">
          You have the right to access, correct, or request deletion of your personal information. 
          To do so, please contact us using the form below.
        </p>
      </motion.div>

      {/* Policy Updates */}
      <motion.div
        id="updates"
        className="mb-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={contentVariants}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Changes to This Statement</h2>
        <p className="text-gray-600 leading-relaxed">
          We may update this Privacy Statement from time to time. The latest version will always be 
          available on this page. By using our website, you agree to the terms of this Privacy Statement.
        </p>
      </motion.div>

      {/* Last Updated */}
      <motion.div
        className="text-sm text-gray-500"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={contentVariants}
        transition={{ duration: 0.6 }}
      >
        Last Updated: {new Date().toLocaleDateString()}
      </motion.div>
    </div>
  );
};

export default PrivacyContent; 